export const navigationMenuWithCMSBlocks = /* GraphQL */ `
    query navigationMenuWithCMSBlocks(
        $category_uid: String!
        $onlyTopLevel: Boolean = false
    ) {
        categories(filters: { category_uid: { eq: $category_uid } }) {
            items {
                image
                ...CategoryLinkFields
                __typename
                children {
                    __typename
                    ...CategoryLinkFields
                    cms_block {
                        content @skip(if: $onlyTopLevel)
                    }
                    children @skip(if: $onlyTopLevel) {
                        ...CategoryLinkFields
                        cms_block {
                            content @skip(if: $onlyTopLevel)
                        }
                    }
                }
            }
        }
    }
    fragment CategoryLinkFields on CategoryInterface {
        name
        url_key
        url_path
        position
        include_in_menu
        has_nicotine
    }
`
export default navigationMenuWithCMSBlocks
